import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';


const renderField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};

class PhysicalExam extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gender: "",
            weight: "",
            abdominalPerimeter: "",
            size: "",
            heartRate: "",
            breathingFrequency: "",
            temperature: "",
            bloodPressure: "",
            BMI: "",
            bodySurface: "",
            load: false,
            listTipos: JSON.parse(sessionStorage.getItem('centroTipos')),
        }
    }
    /*componentDidMount() {
         this.setState({ load: true }, ()=>{
           this.props.loadPhysicalExam().then((load) => {
             this.setState({ load: load },()=>{
                 console.log("cargar examenes fisicos !!");
             });
           }).catch((error)=>{
             console.log(error)
           });
         })    
     }*/

    componentDidMount() {
        console.log("PROPSEXAMS", this.props)
    }
    handlerWeight = (weight) => {
        this.setState({ weight: weight }, () => {
            this.caculateBMI();
            this.calculateSurfaceBody();
        });
    }

    handlerAbdominalPerimeter = (abdominalPerimeter) => {
        this.setState({ abdominalPerimeter: abdominalPerimeter });
    }

    handlerSize = (size) => {
        this.setState({ size: size }, () => {
            this.caculateBMI();
            this.calculateSurfaceBody();
        });
    }

    handlerHeartRate = (heartRate) => {
        this.setState({ heartRate: heartRate });
    }

    handlerBreathingFrequency = (breathingFrequency) => {
        this.setState({ breathingFrequency: breathingFrequency });
    }

    handlerTemperature = (temperature) => {
        this.setState({ temperature: temperature });
    }

    handlerBloodPressure = (bloodPressure) => {
        this.setState({ bloodPressure: bloodPressure });
    }

    handlerSurfaceBody = (bodySurface) => {
        this.setState({ bodySurface: bodySurface });
    }

    caculateBMI = () => {
        if ((this.state.weight !== "" && this.state.weight !== 0) && (this.state.size !== "" && this.state.size !== 0)) {
            var BMI = this.state.weight / (Math.pow(this.state.size, 2)).toFixed(2);
            this.setState({ BMI: BMI });
        }
    }

    handlerBMI = (BMI) => {
        this.setState({ BMI: BMI });
    }

    calculateSurfaceBody = () => {
        var SC = Math.sqrt(((this.state.weight) * (this.state.size)) / 3600);
        this.setState({ bodySurface: SC })
    }

    render() {
        return (
            <Fragment>
                <Col md={12} sm={12} >
                    <div className={"container-wraper-hc physical-exam-form"}>
                        <div className="title-clinic-history">
                            <h4>Antropometria</h4>
                        </div>
                        <Row className='rows'>
                            <Col>
                                <FormControl style={{ width: '50%' }}>
                                    <InputLabel id="demo-simple-select-label">Genero</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        name="select-gender"
                                        id="gender-select"
                                        value={this.props.PhysicalExam.gender}
                                        disabled={this.props.isCloseClinicHistory}
                                        onChange={(e) => {
                                            this.props.handlerPhysicalExam('gender', e.target.value)
                                        }}
                                    >
                                        <MenuItem key={0} value={'Masculino'}>Masculino</MenuItem>
                                        <MenuItem key={1} value={'Femenino'}>Femenino</MenuItem>
                                        <MenuItem key={3} value={'Binario'}>Binario</MenuItem>

                                    </Select>
                                </FormControl>
                            </Col>
                            <Col>
                                <FormControl className="medical-material-form__field" style={{ width: '50%' }}>
                                    <InputLabel id="demo-simple-select-label">Dominancia</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        name="select-dominance"
                                        id="dominance-select"
                                        value={this.props.PhysicalExam.dominance}
                                        //disabled={this.props.PhysicalExam.dominance !== ""}
                                        disabled={this.props.isCloseClinicHistory}
                                        onChange={(e) => { this.props.handlerPhysicalExam('dominance', e.target.value) }}
                                    >
                                        <MenuItem key={0} value={'Diestro'}>Diestro</MenuItem>
                                        <MenuItem key={1} value={'Zurdo'}>Zurdo</MenuItem>

                                    </Select>
                                </FormControl>
                            </Col>
                        </Row>

                        <Row className='rows'>
                            <Col>
                                {/* <span className="form__form-group-label">Peso (Kg)</span>
                            <div className="form__form-group-field">
                                <Field
                                    key={`comment-weight`}
                                    name={`comment-weight`}
                                    component={renderField}
                                    type="number"
                                    placeholder="peso"
                                    //value={this.props.PhysicalExam.weight}
                                    value={this.props.weight}
                                    onChange={(e) => {
                                        //this.props.handlerWeight(e.target.value)
                                        this.props.handlerWeightDataInfo(e.target.value);
                                    }}
                                />
                            </div> */}
                                <TextField
                                    className="fields-phy"
                                    style={{ width: '100%', margin: '0em 0.25em' }}
                                    id="first-last-name-standard-required"
                                    label="Peso (kg)"
                                    type="number"
                                    disabled={this.props.isCloseClinicHistory}
                                    //value={this.props.weight}
                                    value={this.props.PhysicalExam.weight}
                                    onChange={(e) => {
                                        //this.props.handlerWeightDataInfo(e.target.value);
                                        this.props.handlerWeight(e.target.value);
                                    }}
                                />
                            </Col>
                            <Col>
                                {/* <span className="form__form-group-label">Talla (cm)</span>
                            <div className="form__form-group-field">
                                <Field
                                    key={`size`}
                                    name={`size`}
                                    component={renderField}
                                    type="number"
                                    placeholder=""
                                    //value={this.props.PhysicalExam.size}
                                    value={this.props.height}
                                    onChange={(e) => {
                                        //this.props.handlerSize(e.target.value)
                                        this.props.handlerHeightDataInfo(e.target.value)
                                    }}
                                />
                            </div> */}
                                <TextField
                                    className="fields-phy"
                                    style={{ width: '100%', margin: '0em 0.25em' }}
                                    id="first-last-name-standard-required"
                                    label="Talla (cm)"
                                    type="number"
                                    disabled={this.props.isCloseClinicHistory}
                                    value={this.props.PhysicalExam.size}
                                    //value={this.props.height}
                                    onChange={(e) => {
                                        //this.props.handlerHeightDataInfo(e.target.value);
                                        this.props.handlerSize(e.target.value);
                                    }}
                                />
                            </Col>
                            <Col>
                                {/* <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
                                    <input
                                        name="body-mass-index"
                                        placeholder=""
                                        type="number"
                                        value={this.props.PhysicalExam.BMI}
                                        onChange={(e) => { this.props.handlerPhysicalExam('BMI', e.target.value) }}
                                        disabled={true}
                                    />
                                </div> */}
                                <TextField
                                    className="fields-phy"
                                    style={{ width: '100%', margin: '0em 0.25em' }}
                                    id="first-last-name-standard-required"
                                    label="Indice de masa corporal"
                                    type="number"
                                    disabled={true}
                                    //value={this.state.firstLastName}
                                    value={this.props.PhysicalExam.BMI}
                                    // value={this.props.imc}
                                    onChange={(e) => {
                                        //this.props.handlerWeight(e.target.value)
                                        //this.props.handlerHeightDataInfo(e.target.value);
                                    }}
                                />
                            </Col>
                            <Col>
                                {/* <span className="form__form-group-label">Superficie corporal (sc)</span>
                            <div className="form__form-group-field">
                                <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
                                    <input
                                        name="sc"
                                        placeholder=""
                                        type="number"
                                        //value={this.state.bodySurface}
                                        value={this.props.PhysicalExam.bodySurface}
                                        onChange={(e) => { this.props.handlerSurfaceBody(e.target.value) }}
                                        disabled={true}
                                    />
                                </div>
                            </div> */}
                                <TextField
                                    className="fields-phy"
                                    style={{ width: '100%', margin: '0em 0.25em' }}
                                    id="first-last-name-standard-required"
                                    label="Superficie corporal (mc)"
                                    type="number"
                                    disabled={true}
                                    value={this.props.PhysicalExam.bodySurface}
                                    //value={this.props.bodySurface}
                                    onChange={(e) => {
                                        //this.props.handlerWeight(e.target.value)
                                        //this.props.handlerHeightDataInfo(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row className='rows'>
                            <Col>
                                {/* <Field
                        key={`abdominal-perimeter`}
                        name={`abdominal-perimeter`}
                        component={renderField}
                        type="number"
                        placeholder=""
                        value={this.props.PhysicalExam.abdominalPerimeter}
                        disabled={this.props.isCloseClinicHistory}
                        onChange={(e) => {
                            this.props.handlerPhysicalExam('abdominalPerimeter', e.target.value)
                        }}
                    /> */}
                                <TextField
                                    className="fields-phy"
                                    style={{ width: '100%', margin: '0em 0.25em' }}
                                    id="abdominal-perimeter"
                                    label="Perímetro abdominal (cm)"
                                    type="number"
                                    disabled={this.props.isCloseClinicHistory}
                                    value={this.props.PhysicalExam.abdominalPerimeter}
                                    onChange={(e) => {
                                        this.props.handlerPhysicalExam('abdominalPerimeter', e.target.value)
                                    }}
                                />
                            </Col>
                            <Col>
                                {/* <Field
                        key={`temperature`}
                        name={`temperature`}
                        component={renderField}
                        type="number"
                        placeholder="temperatura"
                        value={this.props.PhysicalExam.temperature}
                        disabled={this.props.isCloseClinicHistory}
                        onChange={(e) => { this.props.handlerPhysicalExam('temperature', e.target.value) }}
                    /> */}
                                <TextField
                                    className="fields-phy"
                                    style={{ width: '100%', margin: '0em 0.25em' }}
                                    id="temperature"
                                    label="Temperatura (°C)"
                                    type="number"
                                    disabled={this.props.isCloseClinicHistory}
                                    value={this.props.PhysicalExam.temperature}
                                    onChange={(e) => {
                                        this.props.handlerPhysicalExam('temperature', e.target.value)
                                    }}
                                />
                            </Col>
                            <Col>
                                {/* <Field
                        key={`heart-rate`}
                        name={`heart-rate`}
                        component={renderField}
                        type="number"
                        placeholder="frecuencia cardiaca"
                        disabled={this.props.isCloseClinicHistory}
                        value={this.props.PhysicalExam.heartRate}
                        onChange={(e) => { this.props.handlerPhysicalExam('heartRate', e.target.value) }}
                    /> */}
                                <TextField
                                    className="fields-phy"
                                    style={{ width: '100%', margin: '0em 0.25em' }}
                                    id="heart-rate"
                                    label="Frecuencia Cardiaca (lmp)"
                                    type="number"
                                    disabled={this.props.isCloseClinicHistory}
                                    value={this.props.PhysicalExam.heartRate}
                                    onChange={(e) => {
                                        this.props.handlerPhysicalExam('heartRate', e.target.value)
                                    }}
                                />
                            </Col>
                            <Col>
                                {/*  <Field
                        key={`breathing-frequency`}
                        name={`breathing-frequency`}
                        component={renderField}
                        type="number"
                        placeholder="frecuencia respiratoria"
                        disabled={this.props.isCloseClinicHistory}
                        value={this.props.PhysicalExam.breathingFrequency}
                        onChange={(e) => { this.props.handlerPhysicalExam('breathingFrequency', e.target.value) }}
                    /> */}
                                <TextField
                                    className="fields-phy"
                                    style={{ width: '100%', margin: '0em 0.25em' }}
                                    id="breathing-frequency"
                                    label="Frecuencia respiratoria (resp/min)"
                                    type="number"
                                    disabled={this.props.isCloseClinicHistory}
                                    value={this.props.PhysicalExam.breathingFrequency}
                                    onChange={(e) => {
                                        this.props.handlerPhysicalExam('breathingFrequency', e.target.value)
                                    }}
                                />
                            </Col>

                        </Row>

                        <Row className='rows'>
                            <Col>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                    <div>
                                        {/*   <input
                        key={`blood-pressure`}
                        name={`blood-pressure`}
                        disabled={this.props.isCloseClinicHistory}
                        value={this.props.PhysicalExam.bloodPressureMM}
                        type="number"
                        placeholder='mm'
                        onChange={(e) => { this.props.handlerPhysicalExam('bloodPressureMM', e.target.value) }}
                    /> */}

                                        <TextField
                                            required
                                            className="fields-phy"
                                            style={{ width: '100%', margin: '0em 0.25em' }}
                                            id="blood-pressure"
                                            label="Presión Arterial mm"
                                            type="number"
                                            disabled={this.props.isCloseClinicHistory}
                                            value={this.props.PhysicalExam.bloodPressureMM}
                                            onChange={(e) => {
                                                this.props.handlerPhysicalExam('bloodPressureMM', e.target.value)
                                            }}
                                        />
                                    </div>
                                    <div>
                                        {/*  <input
                        key={`blood-pressure-2`}
                        name={`blood-pressure-2`}
                        placeholder='Hg'
                        disabled={this.props.isCloseClinicHistory}
                        value={this.props.PhysicalExam.bloodPressureHg}
                        type="number"
                        onChange={(e) => { this.props.handlerPhysicalExam('bloodPressureHg', e.target.value) }}
                    /> */}
                                        <TextField
                                            required
                                            className="fields-phy"
                                            style={{ width: '100%', margin: '0em 1em' }}
                                            id="blood-pressure-2"
                                            label="Presión Arterial Hg"
                                            type="number"
                                            disabled={this.props.isCloseClinicHistory}
                                            value={this.props.PhysicalExam.bloodPressureHg}
                                            onChange={(e) => {
                                                this.props.handlerPhysicalExam('bloodPressureHg', e.target.value)
                                            }}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {!!this.props.PhysicalExam.BMI && this.props.PhysicalExam.BMI !== 'NaN' ?
                            <Row className='section-others-exam'>
                                <Row className='rows'>
                                    <Col sm={12} md={6}>
                                        <span className="label-section-others">Aspectos Generales</span>
                                        <Field
                                            className='text-area-phy'
                                            name="textarea-general-features"
                                            component="textarea"
                                            type="text"
                                            value={this.props.PhysicalExam.generalFeatures}
                                            disabled={this.props.isCloseClinicHistory}
                                            onChange={(e) => { this.props.handlerPhysicalExam('generalFeatures', e.target.value) }}
                                        />
                                    </Col>
                                    <Col sm={12} md={6}>
                                        <span className="label-section-others">Cabeza y cara</span>
                                        <Field
                                            className='text-area-phy'
                                            name="textarea-head-face"
                                            component="textarea"
                                            type="text"
                                            disabled={this.props.isCloseClinicHistory}
                                            value={this.props.PhysicalExam.headAndFace}
                                            onChange={(e) => { this.props.handlerPhysicalExam('headAndFace', e.target.value) }}
                                        />
                                    </Col>
                                </Row>
                                <Row className='rows'>
                                    <Col sm={12} md={6}>
                                        <span className="label-section-others">Otorrino</span>
                                        <Field
                                            className='text-area-phy'
                                            name="textarea-otorhino"
                                            component="textarea"
                                            type="text"
                                            disabled={this.props.isCloseClinicHistory}
                                            value={this.props.PhysicalExam.otorhino}
                                            onChange={(e) => { this.props.handlerPhysicalExam('otorhino', e.target.value) }}
                                        />
                                    </Col>
                                    <Col sm={12} md={6}>
                                        <span className="label-section-others">Ojos</span>
                                        <Field
                                            className='text-area-phy'
                                            name="textarea-eyes"
                                            component="textarea"
                                            type="text"
                                            disabled={this.props.isCloseClinicHistory}
                                            value={this.props.PhysicalExam.eyes}
                                            onChange={(e) => { this.props.handlerPhysicalExam('eyes', e.target.value) }}
                                        />
                                    </Col>
                                </Row>
                                <Row className='rows'>
                                    <Col sm={12} md={6}>
                                        <span className="label-section-others">Cuello</span>
                                        <Field
                                            className='text-area-phy'
                                            name="textarea-neck"
                                            component="textarea"
                                            type="text"
                                            disabled={this.props.isCloseClinicHistory}
                                            value={this.props.PhysicalExam.neck}
                                            onChange={(e) => { this.props.handlerPhysicalExam('neck', e.target.value) }}
                                        />
                                    </Col>
                                    <Col sm={12} md={6}>
                                        <span className="label-section-others">Toráx</span>
                                        <Field
                                            className='text-area-phy'
                                            name="textarea-chest"
                                            component="textarea"
                                            type="text"
                                            disabled={this.props.isCloseClinicHistory}
                                            value={this.props.PhysicalExam.chest}
                                            onChange={(e) => { this.props.handlerPhysicalExam('chest', e.target.value) }}
                                        />
                                    </Col>
                                </Row>
                                <Row className='rows'>
                                    <Col sm={12} md={6}>
                                        <span className="label-section-others">Cardiovascular</span>
                                        <Field
                                            className='text-area-phy'
                                            name="textarea-cardiovascular"
                                            component="textarea"
                                            type="text"
                                            disabled={this.props.isCloseClinicHistory}
                                            value={this.props.PhysicalExam.cardioVascular}
                                            onChange={(e) => { this.props.handlerPhysicalExam('cardioVascular', e.target.value) }}
                                        />
                                    </Col>
                                    <Col sm={12} md={6}>
                                        <span className="label-section-others">Pulmonar</span>
                                        <Field
                                            className='text-area-phy'
                                            name="textarea-pulmonary"
                                            component="textarea"
                                            type="text"
                                            disabled={this.props.isCloseClinicHistory}
                                            value={this.props.PhysicalExam.pulmonary}
                                            onChange={(e) => { this.props.handlerPhysicalExam('pulmonary', e.target.value) }}
                                        />
                                    </Col>
                                </Row>
                                <Row className='rows'>
                                    <Col sm={12} md={6}>
                                        <span className="label-section-others">Abdomen</span>
                                        <Field
                                            className='text-area-phy'
                                            name="textarea-abdomen"
                                            component="textarea"
                                            type="text"
                                            disabled={this.props.isCloseClinicHistory}
                                            value={this.props.PhysicalExam.abdomen}
                                            onChange={(e) => { this.props.handlerPhysicalExam('abdomen', e.target.value) }}
                                        />
                                    </Col>
                                    <Col sm={12} md={6}>
                                        <span className="label-section-others">Extremidades</span>
                                        <Field
                                            className='text-area-phy'
                                            name="textarea-limbs"
                                            component="textarea"
                                            type="text"
                                            disabled={this.props.isCloseClinicHistory}
                                            value={this.props.PhysicalExam.limbs}
                                            onChange={(e) => { this.props.handlerPhysicalExam('limbs', e.target.value) }}
                                        />
                                    </Col>
                                </Row>
                                <Row className='rows'>
                                    <Col sm={12} md={6}>
                                        <span className="label-section-others">Neurologico</span>
                                        <Field
                                            className='text-area-phy'
                                            name="textarea-neurological"
                                            component="textarea"
                                            type="text"
                                            disabled={this.props.isCloseClinicHistory}
                                            value={this.props.PhysicalExam.neurological}
                                            onChange={(e) => { this.props.handlerPhysicalExam('neurological', e.target.value) }}
                                        />
                                    </Col>
                                    <Col sm={12} md={6}>
                                        <span className="label-section-others">Genitourinario</span>
                                        <Field
                                            className='text-area-phy'
                                            name="textarea-genitourinary"
                                            component="textarea"
                                            type="text"
                                            disabled={this.props.isCloseClinicHistory}
                                            value={this.props.PhysicalExam.genitourinary}
                                            onChange={(e) => { this.props.handlerPhysicalExam('genitourinary', e.target.value) }}
                                        />
                                    </Col>
                                </Row>
                                <Row className='rows'>
                                    <Col sm={12} md={6}>
                                        <span className="label-section-others">Piel Faneras</span>
                                        <Field
                                            className='text-area-phy'
                                            name="textarea-skin-appendages"
                                            component="textarea"
                                            type="text"
                                            disabled={this.props.isCloseClinicHistory}
                                            value={this.props.PhysicalExam.skin_appendages}
                                            onChange={(e) => { this.props.handlerPhysicalExam('skin_appendages', e.target.value) }}
                                        />
                                    </Col>
                                    <Col sm={12} md={6}>
                                    </Col>
                                </Row>
                            </Row>
                            : null}
                    </div>
                </Col>
            </Fragment>
        )
    }

}


export default reduxForm({
    form: `physical-exam-form`, // a unique identifier for this form
})(withTranslation('common')(PhysicalExam));

